import styled, {css} from 'styled-components';

import {InputFile} from 'components/ui-kit/FileInput';
import {breakpoint, colors, font} from 'theme';

export const ErrorListContaienr = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: auto;
    border: 1px solid ${colors.dangerSecondary};
    border-radius: 4px;
    padding: 4px;
    margin-top: 10px;
`;

export const ErrorList = styled.ul`
    box-sizing: border-box;
    margin: 5px 0;
    padding-left: 17px;
    width: 100%;
    height: auto;
    max-height: 100px;
    overflow-y: auto;
`;
export const ErrorItem = styled.li`
    color: ${colors.danger};
    font-size: 14px;
    line-height: 20px;
`;

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: fit-content;
    gap: 20px;
`;

export const Root = styled.div<{isDrag: boolean}>`
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    width: 100%;
    height: auto;
    min-height: 110px;
    font-size: 12px;
    border: ${(p) => (p.isDrag ? '1px solid #cccccc' : '1px dashed #cccccc')};
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
    outline: none;
    text-align: center;

    &:hover {
        border: ${(p) => p.isDrag && '1px solid #cccccc'};
    }
`;

export const RootContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    height: auto;
    > p {
        margin: 0;
        padding: 0;
    }
`;

export const FileNameContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    width: 100%;
    height: 100%;
`;
export const FileName = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    flex: 1;
    height: 100%;

    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
`;

export const HighlightedText = styled.span`
    color: ${colors.brandPrimary};
`;

export const FileExample = styled.div`
    box-sizing: border-box;
    gap: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    > span {
        color: ${colors.black};
        font-family: ${font.family.primary};
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0;
        text-align: center;
    }

    > a {
        color: ${colors.brandPrimary};
        font-family: ${font.family.primary};
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0;
        text-align: center;
    }
`;

export const FileExampleTitle = styled.span`
    color: ${colors.black};
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    text-align: center;
`;

export const FileExampleList = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    row-gap: 10px;
`;

export const FileExampleItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    flex: 1 1 calc(50% - 5px);
    max-width: 50%;
    height: 100%;
`;

export const FileExampleIcon = styled.div`
    width: 38px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.brandLight};
    border-radius: 4px;
`;

export const FileExampleLink = styled.a`
    color: ${colors.brandPrimary};
    text-decoration: none;
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 11px;
    line-height: 15px;
    letter-spacing: 0;
    text-align: left;
`;

export const FileRejectionErrorList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    height: 100%;
    gap: 5px;
`;

export const FileRejectionErrorMessage = styled.span`
    color: ${colors.danger};
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
`;

export const CustomFileInput = styled(InputFile)`
    @media (max-width: ${breakpoint.phone}) {
        min-width: 200px;
        flex: 1;
        width: 100%;
        font-size: 14px;
    }
`;

export const CustomLink = styled.a`
    color: ${colors.brandPrimary};
    font-size: 14px;
    text-decoration: none;
    margin-top: 4px;
    &:hover {
        text-decoration: underline;
    }

    @media (max-width: ${breakpoint.phone}) {
        min-width: 200px;
        flex: 1;
        text-align: center;
    }
`;

export const CustomLinkAction = styled.span`
    color: ${colors.brandPrimary};
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }

    @media (max-width: ${breakpoint.phone}) {
        min-width: 200px;
        flex: 1;
        text-align: center;
    }
`;
